import React from 'react'
import ManageLoaners from "./components/Loaners"
import Dashboard from '../../Dashboard';

const Loaners = () => {
  return (
    
      <ManageLoaners />
    
  )
}

export default Dashboard(Loaners)